import { CommsService } from '../../services/comms/comms.service';
import { Component, OnInit, OnChanges, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, FormGroup, Validators, FormControl, ReactiveFormsModule } from '@angular/forms';
import { NgbPanelChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../../services/data/data.service';
import { ConfigService } from '../../services/config/config.service';
import { PurchaseOrderService } from '../../services/purchase-order/purchase-order.service';
import { ContractorService } from '../../services/contractor/contractor.service';
import { ValidationService } from '../../services/validation/validation.service';
import { UserService } from '../../services/user/user.service';
import { InvoiceService } from '../../services/invoice/invoice.service';


@Component({
	selector: 'pcm-add-user-modal',
	templateUrl: './data-modal-add-user.component.html',
	styleUrls: ['../data-modal/data-modal.component.scss', '../data-page-timesheet/data-page-timesheet.component.scss',
				'./data-modal-add-user.component.scss']
})
export class DataModalAddUserComponent implements OnInit, OnChanges, OnDestroy {

	public title = 'Add Users';

	@Output() formSubmit: EventEmitter<any> = new EventEmitter();
	@Output() closeAddUserModelEmitter: EventEmitter<any> = new EventEmitter();

	private users;
	public usersList = [{ email: '', role: '' }];
	private isSuccessfulUpload;
	private message;
	private fileUploadUsers = [];
	private file: File;
	private dataObj;

	constructor(
		public dataService: DataService,
		public configService: ConfigService,
		public purchaseOrderService: PurchaseOrderService,
		public contractorService: ContractorService,
		public validationService: ValidationService,
		public userService: UserService,
		public formBuilder: UntypedFormBuilder,
		public invoiceService: InvoiceService,
		public commsService: CommsService
	) {}

	ngOnInit() {
		this.dataObj = this.userService.uploadDataObj;
	}

	ngOnChanges(event) {

	}

	ngOnDestroy() {	}

	pageFormSubmit(event) {
		console.log('DATA MODAL FORM SUBMIT', event);
		this.formSubmit.emit(event);
	}

	onCloseAddUserModel(event) {
		this.closeAddUserModelEmitter.emit(event);
	}

	onAddNewUser() {
		const newUser = { email: '', role: '' };
		this.usersList.push(newUser);
		this.cancleFileUpload();
	}

	onUpload(file) {
		this.userService.uploadUsers(file);
	}

	onSubmit() {
		// if (this.isSuccessfulUpload) {
		if (this.userService.fileUploadedUsers.length > 0) {
			this.userService.createUsers(this.userService.fileUploadedUsers);
		}else {
			this.userService.createUsers(this.usersList);
		}
		this.userService.showAddUsersModal = false;
	}

	onUpdateUsername(username) {
		console.log(username.trim()); // trim
	}

	onRemoveUser(index) {
		this.usersList.splice(index, 1);
	}

	isSubmitable() {
		let canSubmit = false;
		const isValidTab = this.userService.getActiveTab(this.userService.tabsData.uploadTabs)['prop'] === 'valid';
		if (!this.userService.isManualAdd && isValidTab && this.userService.fileUploadedUsers.length > 0) {
			canSubmit = true;
		}
		if ( this.userService.isManualAdd && this.usersList.length > 0 ) {
			canSubmit = true;
			for (let i = 0; i < this.usersList.length; i++) {
				const user = this.usersList[i];
				if (!this.isEmailValid(user.email) || user.role.length === 0) {
					canSubmit = false;
					break;
				}
			}
		}
		return canSubmit;
	}

	isEmailValid(email) {
		let valid = false;
		if (email && email.length > 0) {
			if (email.match(this.validationService.getPattern('email'))) {
				valid = true;
			}
		}
		return valid;
	}

	cancleFileUpload() {
		this.userService.fileUploadedUsers = [];
		this.isSuccessfulUpload = false;
	}

	cancleAddUser() {
		this.usersList = [];
	}

	/*
	changeRoles($event, index) {
		if ($event.length === 0) {
			this.roles[index] = this.configService.getRolesByPersona();
		}else if ($event.length >= 6) {
			this.usersList[index] = { email: '', selectedRoles: [] };
			return;
		}
		$event.forEach(element => {
			switch (element.id) {
				case 'pm':
				case 'sa':
				case 'tra':
				case 'contractor':
				this.roles[index] = [
					{
						id: 'pm',
						itemName: 'Project Manager'
					},
					{
						id: 'sa',
						itemName: 'Supplier Administrator'
					}, {
						id: 'tra',
						itemName: 'Delegated Time Verifier'
					}, {
						id: 'contractor',
						itemName: 'Contractor'
					}
				];
				break;

				case 'srm':
				case 'sam':
				case 'cca':
				this.roles[index]  = [
					{
						id: 'srm',
						itemName: 'Supplier Relations Manager'
					}, {
						id: 'sam',
						itemName: 'Supplier Account Manager'
					}, {
						id: 'cca',
						itemName: 'Contractor Administrator'
					}
				];
				break;

				default:
				this.roles[index]  = this.configService.getRolesByPersona();
				break;
			}
		});
			console.log($event);
	}
	*/
}
